import sha256 from 'crypto-js/sha256';
import { DEFAULT_SYSTEM_CONFIGURATIONS } from './constants';

export const getAnonymousUserID = async (aactualUserProfile) => {
	let message1 = aactualUserProfile.email
	for (let i=0; i < aactualUserProfile.email.length; i++){
		message1 = sha256(message1)
	}

	let message2 = aactualUserProfile.googleId
	for (let i=0; i < aactualUserProfile.googleId.length; i++){
		message2 = sha256(message2)
	}
	return message1+message2;
}

export const getResearchID = (encryptedID) => {
	const researchID = encryptedID.substring(0, 3) + encryptedID.substring(50, 53) + encryptedID.substring(125, 128) + encryptedID.substring(100, 101)
	return researchID
}

export const getScreenType = () => {
	return window.screen.width + " x " + window.screen.height
}

export const getDefaultSystemConfiguration = (configurationName) => {
	return DEFAULT_SYSTEM_CONFIGURATIONS[configurationName]
}